import React, { useState } from 'react';
import ChangePasswordModal from '../components/admin/ChangePasswordModal';

const AdminSettings = () => {
  const [openPassword, setOpenPassword] = useState(false);

  return (
    <div className="px-[1.25rem] py-[1.25rem]">
      <div className="rounded-[18px] border border-[#262626] bg-[#111] p-[1.25rem]">
        <p className="text-[12px] font-semibold uppercase tracking-[0.18em] text-[#EEC24B]">Settings</p>
        <h2 className="mt-[0.35rem] text-[28px] font-bold text-white">Admin account</h2>
        <p className="mt-[0.35rem] max-w-[760px] text-[15px] text-[#BDBDBD]">
          Manage your admin password from the dedicated settings screen.
        </p>

        <button
          type="button"
          onClick={() => setOpenPassword(true)}
          className="mt-[1rem] rounded-lg bg-[#EEC24B] px-[1rem] py-[0.9rem] text-[15px] font-semibold text-black"
        >
          Change password
        </button>
      </div>

      <ChangePasswordModal open={openPassword} onClose={() => setOpenPassword(false)} />
    </div>
  );
};

export default AdminSettings;
